import PreLoader from '../../modules/preloader';
require('./impromptu');
let form = require('../form/form');

let size = require('../../modules/size');

let autoComplete = require('./../autocomplete/autocomplete');

import Trackers from '../tracker/tracker';
import ReCaptcha from '../google-captcha';

let captcha, bxCaptchaSid;

let trackers = new Trackers();

let changeState = function(v) {
    if (v == 'login') {
        $.prompt.goToState('loginForm');
    } else if (v == 'reg') {
        trackers.onPMbtnReg();
        $.prompt.goToState(curRegForm);
    } else if (v == 'passrecovery') {
        $.prompt.goToState('passRecoveryForm');
    } else if (v == 'thankyou') {
        $.prompt.goToState('thankYouForm');
    } else {
        return 'nogo';
    }
};

let curRegForm = 'regForm';

let registration = $('.js-registration-head');
let authPromptHeader = registration
    .find('.js-prompt-header')
    .remove()
    .html();
let thankYouPrompt = $('.js-thankyou-prompt').html();

let authPrompt = {
    loginForm: {
        html: $('.js-auth-component')
            .remove()
            .html(),
        submit: function(e, v, m) {
            // РКН блоктрует google и отсутствие grecaptcha ломает авторизацию
            window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};

            if (!captcha) {
                captcha = new ReCaptcha('.captcha-field', grecaptcha);
            }

            let changeStateRes = changeState(v);
            if (changeStateRes == 'nogo') {
                let $params = $.extend({}, form.formValidateDefaults, {
                    rules: {
                        login_email: { required: true, email: true },
                        login_password: { required: true },
                        login_remember_me: {}
                    },
                    messages: {
                        login_email: {
                            required: 'Не указан e-mail',
                            email: 'Указан неверный e-mail'
                        },
                        login_password: { required: 'Указан неверный пароль' }
                    },
                    submitHandler: function() {
                        let email = $('.jqistate input[name=login_email]').val();
                        let password = $('.jqistate input[name=login_password]').val();
                        let remember = $('.jqistate input[name=login_remember_me]').is(':checked');
                        let sessid = $('.jqistate input[name=sessid]').val();

                        if (captcha.key && !captcha.exists()) {
                            captcha.render();
                        }

                        if (captcha.rendered() && !captcha.completed()) {
                            $('.js-login_error').text('Необходимо выполнить captcha');
                            return;
                        }

                        let sendObj = {
                            email: email,
                            password: password,
                            isRemember: remember,
                            sessid: sessid
                        };

                        if (bxCaptchaSid) {
                            sendObj = Object.assign(sendObj, {
                                'g-recaptcha-response': captcha.completed() || '',
                                captcha_sid: bxCaptchaSid,
                                captcha_word: Math.random()
                                    .toString(36)
                                    .substr(2, 5)
                                    .toUpperCase()
                            });
                        }
                        const loader = new PreLoader();
                        loader.show();

                        $.ajax({
                            method: 'POST',
                            url: '/ajax/action/personal_authorize/get_authorization_data/',
                            data: sendObj,
                            async: false,
                            success: function(response) {
                                loader.hide(0);
                                if (response['code'] !== 200) {
                                    $('.js-login_error').text(response['message']);
                                    $('.jqistate input[name=login_password]').val('');

                                    bxCaptchaSid = response['data']['BX_CAPTCHA_CODE'];

                                    if (response['data']['CAPTCHA_CODE'] && !captcha.rendered()) {
                                        captcha.key = response['data']['CAPTCHA_CODE'];
                                        captcha.render();
                                        return;
                                    }

                                    if (captcha.rendered()) {
                                        captcha.reset();
                                    }
                                } else {
                                    location.replace(location.href);
                                }
                            },
                            error: function () {
                                loader.hide(0);
                            }
                        });
                    }
                });
                let $form = m.closest('form');
                $form.validate($params);
                $('.js-login_error').text('');
            }
            e.preventDefault();
        }
    },
    regForm: {
        html: authPromptHeader + registration.find('.js-reg-component').html(),
        submit: function(e, v, m) {
            let changeStateRes = changeState(v);
            curRegForm = 'regForm';
            if (changeStateRes == 'nogo') {
                let $params = $.extend({}, form.formValidateDefaults, {
                    rules: {
                        EMAIL: {
                            required: true,
                            email: true,
                            remote: {
                                url: '/ajax/action/personal_registration/checkEmailTaken/',
                                type: 'get',
                                dataType: 'json',
                                dataFilter: function(response) {
                                    let result = true;
                                    if (response) {
                                        let json = $.parseJSON(response);
                                        if (json.data[0] === 'false') {
                                            result = false;
                                        }
                                    }
                                    return result;
                                }
                            }
                        },
                        PASSWORD: {
                            required: true,
                            minlength: 6
                        },
                        WORK_CITY: { required: true },
                        UF_PHONE: { required: true, phoneMask: true },
                        NAME: { required: true },
                        reg_user_type: { required: true }
                    },
                    messages: {
                        EMAIL: {
                            required: 'Не указан e-mail',
                            email: 'Указан неверный e-mail',
                            remote: 'Пользователь с таким email уже существует'
                        },
                        PASSWORD: {
                            required: 'Не указан пароль',
                            minlength: 'Длина пароля - не менее 6 символов'
                        },
                        WORK_CITY: { required: 'Не указан город' },
                        UF_PHONE: {
                            required: 'Не указан телефон',
                            phoneMask: 'Указан неверный телефон'
                        },
                        NAME: { required: 'Не указано имя' },
                        reg_user_type: { required: 'Не выбран тип' }
                    },
                    submitHandler: function() {
                        let currentCaptchaId = window.Recaptchafree.items[window.Recaptchafree.items.length - 1];
                        let recaptchaResponse = grecaptcha.getResponse(currentCaptchaId) || '';

                        if (!recaptchaResponse) {
                            $('.js-server_errors')
                                .html('Необходимо выполнить captcha!' + '<br>')
                                .addClass('form__error-msg');
                            return;
                        }

                        let responseField = $('<input/>', {
                            type: 'text',
                            name: 'g-recaptcha-response',
                            val: recaptchaResponse
                        });

                        let dataRegForm = $.prompt.getState('regForm').find('.js-reg-form');
                        let regResult = $.merge(
                            $.merge(dataRegForm, $.prompt.getState('regForm').find('[name=reg_user_type]')),
                            responseField
                        );
                        let userType = $.prompt
                            .getState('regForm')
                            .find('[name=reg_user_type]')
                            .val();

                        const loader = new PreLoader();
                        loader.show();

                        $.ajax({
                            url: '/ajax/action/personal_registration/registration/',
                            data: regResult,
                            type: 'POST',
                            success: function(response) {
                                loader.hide(0);
                                if (response['code'] == 200) {
                                    let trackers = new Trackers();
                                    trackers.onSignUpEnd({ gtm: 'registrationDone' });
                                    if (userType === 'individual') {
                                        $('.js-thankyou-wholesale').remove();
                                    } else {
                                        $('.js-thankyou-retail').remove();
                                    }
                                    $('.jqiclose').remove();
                                    $('.jqiform').css('padding-bottom', 0);
                                    grecaptcha.reset(currentCaptchaId);
                                    trackers.onPMfrmReg();
                                    changeState('thankyou');
                                } else {
                                    $.each(response['data']['errors'], function() {
                                        $('.js-server_errors')
                                            .html(this + '<br>')
                                            .addClass('form__error-msg');
                                        bxCaptchaSid = response['data']['BX_CAPTCHA_CODE'];
                                        $('input[name="captcha_sid"]').val(bxCaptchaSid);
                                        grecaptcha.reset(currentCaptchaId);
                                    });
                                }
                            },
                            error: function () {
                                loader.hide(0);
                            }
                        });
                    }
                });

                let $form = m.closest('form');
                $form.validate($params);
            }
            e.preventDefault();
        }
    },
    passRecoveryForm: {
        html: $('.js-forgotpasswd-component')
            .remove()
            .html(),
        submit: function(e, v, m) {
            let changeStateRes = changeState(v);
            if (changeStateRes == 'nogo') {
                let $form = m.closest('form');

                let $params = $.extend({}, form.formValidateDefaults, {
                    rules: {
                        USER_EMAIL: { required: true, email: true }
                    },
                    messages: {
                        USER_EMAIL: {
                            required: 'Не указан e-mail',
                            email: 'Указан неверный e-mail'
                        }
                    },
                    submitHandler: function() {
                        let email = $('.jqistate input[name="USER_EMAIL"]').val();
                        let inputs = $.prompt.getState('passRecoveryForm').find(':input');
                        inputs = inputs.serialize();
                        let recoveryResult;
                        let code;
                        $.ajax({
                            url: '/ajax/action/personal_forgotpasswd/check_user/?email=' + email,
                            async: false,
                            complete: function(response) {
                                recoveryResult = response.responseJSON['data'];
                                code = response.responseJSON['code'];
                            }
                        });
                        if (code !== 200) {
                            $('.login_email_error-js')
                                .text(recoveryResult['message'])
                                .addClass('form__error-msg');
                        } else {
                            $.ajax({
                                type: 'POST',
                                data: inputs,
                                success: function() {
                                    $.prompt
                                        .getState('passRecoveryForm')
                                        .find('.form')
                                        .html(recoveryResult['message']);
                                    $.prompt.position();
                                }
                            });
                        }
                    }
                });

                $form.validate($params);
            }
            e.preventDefault();
        }
    },
    thankYouForm: {
        html: thankYouPrompt,
        submit: function(e) {
            e.preventDefault();
            location.replace(location.href);
        }
    }
};

module.exports = authPrompt;

jQuery(function() {
    $(document).on('click', '.js-jqi-show-login', function(e) {
        e.preventDefault();
        $.prompt(authPrompt, {
            initialState: 'loginForm',

            statechanging: function(e, from, to) {
                if (to !== 'regForm') {
                    return;
                }

                window.Recaptchafree.render();
            }
        });
    });

    $(document).on('click', '.js-jqi-show-reg', function(e) {
        e.preventDefault();
        trackers.onSignUp();
        trackers.onPMbtnReg();
        $.prompt(authPrompt, {
            initialState: 'regForm',
            statechanging: function(e, from, to) {
                if (to !== 'regForm') {
                    return;
                }

                window.Recaptchafree.render();
            }
        });
    });

    $(document).on('click', '.js-jqi-show-passrecovery', function(e) {
        e.preventDefault();
        $.prompt(authPrompt, { initialState: 'passRecoveryForm' });
    });

    $(document).on('click', '.js-expand-reg-promo', function() {
        let $regPromoBlock = $(this).closest('.prompt__reg-promo');
        $regPromoBlock.addClass('prompt__reg-promo--shown');
    });

    $(document).on('click', '.js-mobile-auth-btn', function(e) {
        e.preventDefault();

        if (window.innerWidth < size.desktop) {
            $.prompt(authPrompt, {
                initialState: 'loginForm',
                statechanging: function(e, from, to) {
                    if (to !== 'regForm') {
                        return;
                    }

                    window.Recaptchafree.render();
                }
            });
        }
    });

    $(document).on('click', '.js-mobile-user-btn', function() {
        let userFormHtml = '';
        $.ajax({
            url: '/ajax/component/maximaster:personal.widget/user/',
            async: false,
            success: function(data) {
                userFormHtml = data['html'];
            }
        });

        let userPrompt = {
            userForm: {
                html: userFormHtml
            }
        };

        if (window.innerWidth < size.desktop) {
            $.prompt(userPrompt, {
                initialState: 'userForm',
                statechanging: function(e, from, to) {
                    if (to !== 'regForm') {
                        return;
                    }

                    window.Recaptchafree.render();
                }
            });
        }
    });

    $(document).on('click', '.js-user-logout-btn', function() {
        $.ajax({
            url: '/ajax/action/personal_authorize/logout/',
            success: function() {
                location.replace(location.href);
            }
        });
    });

    $(document).on('focus', '.js-autocomplete', function() {
        autoComplete.setAutocomplete($('.js-autocomplete'));
    });
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu-auth.js